export default __webpack_public_path__ + "static/media/J'sLLogo.4db4bec6.png";